import { useIntl } from "react-intl";
import { WmButton } from "@watermarkinsights/ripple-react";
import type { SourceProductConfig } from "../ai-chat-source-products";


interface MessageSourcesProps {
  products: SourceProductConfig[];
  isExpanded: boolean;
  onToggle: () => void;
  isAttachedToChart?: boolean;
}

export const MessageSources = ({
  products,
  isExpanded,
  onToggle,
  isAttachedToChart = false,
}: MessageSourcesProps) => {
  const intl = useIntl();

  return (
    <div
      className={`tcw-sources${isAttachedToChart ? " tcw-sources--chart" : ""}`}
    >
      <hr className="tcw-sources-divider" />
      <WmButton
        button-type="textonly"
        icon="#collapsed"
        iconSize="1rem"
        iconRotate={isExpanded ? 90 : 0}
        className="tcw-sources-toggle"
        onClick={onToggle}
        aria-expanded={isExpanded}
      >
        {intl.formatMessage({ id: "app.toolboxChat.action.sources" })}
      </WmButton>
      {isExpanded && (
        <div className="tcw-sources-list">
          {products.map((product) => (
            <div key={product.id} className="tcw-source-item">
              {intl.formatMessage({ id: product.labelId })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
